import Layout from '~/layouts/blank.vue';
import { ContentMap, } from './index';

interface InvestmentAreaOptions {
	contentMapData: typeof import('./content-map-data.json');
	googleMapsApiKey: string;
	elementToMount: string;
}

function isOptionWithConfig(obj: unknown): obj is InvestmentAreaOptions {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
	const objAny = obj as any;

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	return typeof objAny.googleMapsApiKey === 'string' && typeof objAny.contentMapData === 'object';
}

function initInvestmentArea(e: CustomEventInit<InvestmentAreaOptions>) {
	const options = e.detail;
	if (options === undefined || !isOptionWithConfig(options)) {
		console.error('Invalid options to setup ContentMap app', options);
		return;
	}

	ContentMap(Layout, {
		googleMapsApiKey: options.googleMapsApiKey,
	},
	options.contentMapData, options.elementToMount);
}

const swWindow = window as { sw? : { contentMap: boolean, }, };
swWindow.sw = swWindow.sw ?? {
	contentMap: false,
};

if (!swWindow.sw.contentMap) {
	// Only add one listner if script added multiple times
	window.addEventListener('sw:content-map:init', initInvestmentArea);
	swWindow.sw.contentMap = true;
}
